import { graphql } from '../../types/swarm/gql'

export const InvestAssetsQuery = graphql(`
  query InvestAssets($filter: AssetToken_filter, $limit: Int, $skip: Int) {
    assetTokens(where: $filter, first: $limit, skip: $skip) {
      id
      name
      symbol
      decimals
      kya
      enabled
      isOnSafeGuard
      frozen
    }
  }
`)
